import React from "react";
import GalleryTemplate from "../components/gallery/GalleryTemplate";
import { getSEOData } from "../utils/seo";

function Gallery() {
  const seoData = getSEOData("project-gallery");
  return <GalleryTemplate seoData={seoData} />;
}

export default Gallery;
